import { hasDemand } from "lib/authorization/has-demand"
import { isEnabled } from "lib/@components/feature"
import { AUTHORING_REVIEW_COMPONENT_DEMAND } from "authoring/lib/constants/authoring-permissions.mjs"
import { FEATURE_FLAG_COMPONENT_REVIEW } from "../../feature-flag-component-review"

/**
 * Whether the current user can review draft components.
 *
 * Gates the Draft Components view in the same way ApproveTaskButton gates the approve
 * action. This is a UI convenience only — the server independently enforces the demand
 * on any drafts query.
 *
 * @returns {boolean}
 */
export function canReviewComponents() {
    return isEnabled(FEATURE_FLAG_COMPONENT_REVIEW) && hasDemand(AUTHORING_REVIEW_COMPONENT_DEMAND)
}
